<script setup>
import { formatDate } from '@utils/date'
import Button from '@components/global/button.vue'

defineProps(['articles', 'title'])
</script>

<template>
  <section class="container flex flex-col gap-10">
    <div class="flex h-full w-full items-center justify-between gap-4">
      <h2 class="break-words font-heading text-h2 font-medium uppercase leading-tight text-sf-purple-base">
        {{ title }}
      </h2>
    </div>

    <div class="flex w-full flex-wrap justify-center gap-4">
      <article
        v-for="article in articles"
        :key="article.id"
        class="relative flex h-full w-full max-w-[420px] items-center gap-2 overflow-hidden rounded-large border border-sf-purple-base bg-bg-dark p-2"
      >
        <Button :to="{ name: 'article', params: { slug: article.slug } }">
          <div class="flex flex-col items-start justify-start overflow-hidden rounded-medium">
            <!-- Image Container -->
            <div class="relative h-[270px] overflow-hidden rounded-medium bg-bg-dark">
              <img class=" w-full" :src="article.image" :alt="article.title" />

              <svg
                class="absolute left-0 top-0"
                width="410"
                height="422"
                viewBox="0 0 305 422"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.79075 136.312L108.362 -151.265C123.449 -193.565 69.1266 -226.152 40.7238 -191.839L-394.376 333.789C-410.607 353.397 -404.662 383.543 -382.162 395.722L360.244 797.582C379.672 808.098 403.564 800.673 413.609 780.997L630.879 355.397C643.19 331.282 628.782 301.596 602.358 296.632L36.3705 190.304C12.0375 185.733 -2.61133 159.869 5.79075 136.312Z"
                  fill="#060412"
                />
              </svg>
            </div>

            <!-- Content -->
            <div class="flex flex-col gap-3 px-5 pb-8 pt-5">
              <!-- Date -->
              <div class="flex items-center gap-3">
                <div class="h-1.5 w-1.5 bg-purple-300"></div>
                <time
                  class="break-words font-body text-body-xs font-medium uppercase leading-[15.60px] tracking-[0.12px] text-purple-300"
                >
                  {{ formatDate(article.published_at) }}
                </time>
              </div>

              <!-- Title -->
              <h3
                class="line-clamp-3 h-20 break-words font-heading text-h5 font-semibold uppercase leading-6 text-text-base"
              >
                {{ article.title }}
              </h3>
            </div>
          </div>
        </Button>
      </article>
    </div>

    <div class="w-fit self-center">
      <Button class="btn-outline">load more</Button>
    </div>
  </section>
</template>
